export default import.meta.ROLLDOWN_FILE_URL_WYynaTR27qS79TqavLPOQA